import useModule from "./useModule";

const useUtility = (path) => {
    const dest = path.split('.');
    const module = useModule(dest[0]);
    if(!module) return null;
    return module.utilities[dest[1]];
};

export default useUtility;